module.exports = __webpack_public_path__ + "assets/img/header-ged-infolettre.4b37f255.jpg";